<template>
  <span
    v-if="value"
    :class="{'text-success': value > 0}"
  >{{ str }}</span>
</template>

<script>
import helper from '../../../mixins/helper'

/**
 * На сколько изменилось значение позиции.
 */
export default {
  name: 'PositionsDiff',
  mixins: [helper],
  props: {
    /**
     * Значение на сколько изменилась позиция.
     */
    value: {
      type: Number,
      required: true
    }
  },
  computed: {
    /**
     * Округленное значение.
     *
     * @returns {number}
     */
    valueRound () {
      return this.round(this.value)
    },
    /**
     * Текст для вывода.
     *
     * @returns {string}
     */
    str () {
      return this.valueRound > 0 ? `+${this.valueRound}` : this.valueRound.toString()
    }
  }
}
</script>
